import { render, staticRenderFns } from "./SwitchCheckbox.vue?vue&type=template&id=5acefe41&scoped=true&"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=js&"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCheckbox.vue?vue&type=style&index=0&id=5acefe41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acefe41",
  null
  
)

export default component.exports